export default __webpack_public_path__ + "static/media/team94.b3d597a9.JPG";